import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteMatch } from 'react-router-dom'

import IconCalendar from '@cimpress-technology/react-streamline-icons/lib/IconCalendar'
import IconCogDouble from '@cimpress-technology/react-streamline-icons/lib/IconCogDouble'
import IconMultipleUsers from '@cimpress-technology/react-streamline-icons/lib/IconMultipleUsers'
import IconSearch from '@cimpress-technology/react-streamline-icons/lib/IconSearch'
import IconShipmentBox from '@cimpress-technology/react-streamline-icons/lib/IconShipmentBox'
import IconShipmentTruck from '@cimpress-technology/react-streamline-icons/lib/IconShipmentTruck'
import IconShop from '@cimpress-technology/react-streamline-icons/lib/IconShop'
import IconTruckConfigure from '@cimpress-technology/react-streamline-icons/lib/IconTruckConfigure'

import { AdvancedUserContainer } from '../../../common/components/AdvancedUserContainer'
import { config } from '../../../common/config/config'
import { useLogisticsLocation } from '../../LocationContext'
import styles from './ConfigureCard.module.css'
import NavigationExternalLink from './NavigationExternalLink'
import NavigationLink from './NavigationLink'

export default function ConfigureCard() {
  const { t } = useTranslation()

  const match = useRouteMatch()

  const { logisticsLocation } = useLogisticsLocation()

  return (
    <div className="card card-minimal" style={{ marginBottom: '20px' }}>
      <div className="card-header">
        <h5 className="card-title">
          {t('locations.viewLocationPage.configuration')}
        </h5>
      </div>
      <div className={`${styles.configuration} card-block`}>
        <ul className="list-group">
          <NavigationLink
            url={`${match.url}/calendars`}
            text={t('common.calendars.calendars')}
            icon={IconCalendar}
          />
          <NavigationLink
            url={`${match.url}/user-management`}
            text={t('userManagement.userManagement')}
            icon={IconMultipleUsers}
          />
          <NavigationExternalLink
            url={`${config.qcm}/ui/fulfillmentLocations/${logisticsLocation.id}`}
            text={t('locations.viewLocationPage.ccmConfiguration')}
            icon={IconTruckConfigure}
            target="_blank"
          />
          <NavigationLink
            url={`${match.url}/packing`}
            text={t('packing.packing')}
            icon={IconShipmentBox}
          />
          <NavigationLink
            url={`${match.url}/shipping`}
            text={t('shipping.shipping')}
            icon={IconShipmentTruck}
          />
          <NavigationLink
            url={`${match.url}/shop-floor`}
            text={t('shopFloor.shopFloor')}
            icon={IconShop}
          />
          <NavigationLink
            url={`/location/${logisticsLocation.id}/history`}
            text={
              <>
                {t('common.history')}{' '}
                <span className="badge badge-info">beta</span>
              </>
            }
            icon={IconSearch}
          />
          <AdvancedUserContainer>
            <NavigationLink
              url={`${match.url}/advanced-overview`}
              text="Advanced Overview"
              icon={IconCogDouble}
            />
          </AdvancedUserContainer>
        </ul>
      </div>
    </div>
  )
}
